<template>
  <div class="control-panel__userAccess">
    <div
      class="control-panel__addUser"
      v-if="!isBusy"
    >
      <b-button
        variant="primary"
        @click="showCreateUserModal"
      >
        <icon name="plus" />
        <span>Create user</span>
      </b-button>
    </div>
    <b-table
      :items="usersReady"
      :fields="fields"
      :busy="isBusy"
      class="mt-3"
      outlined
      hover
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <strong>Loading...</strong>
      </div>

      <div slot="email" slot-scope="row">
        <span v-if="row.item.email">{{ row.item.email }}</span>
        <i v-else style="color: #bbb;">(anonymous)</i>
      </div>

      <template slot="isAdmin" slot-scope="row">
        <b-form-checkbox
          :checked="isAdmin(row.item.uid)"
          :disabled="userId === row.item.uid"
          @change="toggleAdminPermission(row.item.uid)"
        >
          is admin
        </b-form-checkbox>
      </template>

      <template slot="dAccess" slot-scope="row">
        <b-button
          variant="primary"
          size="sm"
          @click="showDashboardsAccessModal(row.item)"
        >
          <icon name="pencil" />
          <span>Edit</span>
        </b-button>
      </template>
    </b-table>
    <DashboardsAccessModal
      :dashboards="dashboards"
      :access="access"
      :profilesInfo="profilesInfo"
    />
    <CreateUserModal
      :users="users"
      :dashboards="dashboards"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import user from '@/services/user'
import db from '@/services/db'
// components
import DashboardsAccessModal from './modals/DashboardsAccess'
import CreateUserModal from './modals/CreateUser'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    DashboardsAccessModal,
    CreateUserModal
  },
  data () {
    return {
      users: null,
      access: null,
      dashboards: null,
      profilesInfo: null,
      isBusy: true,
      fields: [
        { key: 'email', label: 'Email' },
        { key: 'createdOn', label: 'Created on' },
        { key: 'lastSignIn', label: 'Last sign in' },
        { key: 'isAdmin', label: 'Is Admin' },
        { key: 'dAccess', label: 'Dashboard Access' }
      ]
    }
  },
  computed: {
    ...mapState([
      'userId'
    ]),
    usersReady () {
      if (!this.users || !this.access) return null

      const users = []

      for (let idx in this.users) {
        const user = this.users[idx]
        
        if (typeof user !== 'object') continue

        const userReady = {
          uid: user.uid,
          email: user.email,
          createdOn: user.metadata.creationTime,
          lastSignIn: user.metadata.lastSignInTime
        }

        if (this.userId === user.uid) userReady['_rowVariant'] = 'success'

        users[idx] = userReady
      }

      return users
    }
  },
  methods: {
    isAdmin (uid) {
      return (this.access.Admin[uid] && this.access.Admin[uid].all) ? true : false
    },
    toggleAdminPermission (uid) {
      if (this.isAdmin(uid)) {
        delete this.access.Admin[uid]
        db.access.removeUserAdminRight(uid)
      } else {
        this.access.Admin[uid] = { all: true }
        db.access.setUserAsAdmin(uid)
      }
    },
    showDashboardsAccessModal (item) {
      const data = {
        uid: item.uid,
        email: item.email
      }
      eventBus.$emit('showDashboardsAccessModal', data)
    },
    saveDashboardAccess (data) {
      const { uid, dId, role, profileInfo } = data
      const dashboards = Object.assign({}, this.dashboards)
      const access = Object.assign({}, this.access)
      const profilesInfo = Object.assign({}, this.profilesInfo)

      if (!dashboards[dId].sharedWith) dashboards[dId].sharedWith = {}

      dashboards[dId].sharedWith[uid] = true
      if (!access.Dashboard[uid]) access.Dashboard[uid] = {}
      if (access.Dashboard[uid][dId]) access.Dashboard[uid][dId] = {}
      access.Dashboard[uid][dId] = { [role]: true }

      if (profileInfo) {
        profilesInfo[uid] = profileInfo
      }

      db.access.saveDashboardAccess(data)

      this.dashboards = dashboards
      this.access = access
      this.profilesInfo = profilesInfo
    },
    removeDashboardAccess (data) {
      const { uid, dId } = data
      const dashboards = Object.assign({}, this.dashboards)
      const access = Object.assign({}, this.access)

      delete dashboards[dId].sharedWith[uid]
      delete access.Dashboard[uid][dId]

      db.access.removeDashboardAccess(data)

      this.dashboards = dashboards
      this.access = access
    },
    showCreateUserModal () {
      eventBus.$emit('showCPCreateUserModal')
    }
  },
  async created () {
    this.users = await user.getUserList()
    this.access = await db.access.read()
    this.dashboards = await db.dashboards.readAll()
    await new Promise((resolve) => {
      db.getProfilesInfo((profilesInfo) => {
        this.profilesInfo = profilesInfo
        resolve()
      })
    })

    this.isBusy = false

    eventBus.$on('saveDashboardAccess', (data) => {
      this.saveDashboardAccess(data)
    })
    eventBus.$on('removeDashboardAccess', (data) => {
      this.removeDashboardAccess(data)
    })
  }
}
</script>

<style lang="scss">
  .control-panel {
    &__addUser {
      padding: {
        top: 10px;
        bottom: 5px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ControlPanel/UserAccess.vue